import React from 'react'
import { useParams } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import EmptyPageState from 'components/empty-page-state'
import PartyPopperIcon from 'components/icons/party-popper-icon'
import useDetailStyles from '../../detail-styles'
import LessonPlanDetailView from '../../components/lesson-plan-detail-view'
import useCoachActivityHit from '../../hooks/use-coach-activity-hit'
import useCoachActivityHits from '../../hooks/use-coach-activity-hits'

const SinglePlansPage = () => {
  const classes = useDetailStyles()
  const { id } = useParams()
  const { hit: planHit, isLoading: isPlanLoading } = useCoachActivityHit(id)
  const {
    hits: activityHits,
    isLoading: areActivitiesLoading,
  } = useCoachActivityHits(planHit)

  if (isPlanLoading || areActivitiesLoading) {
    return <Box className={classes.page} />
  }

  if (!planHit) {
    return (
      <Box className={classes.page}>
        <Grid item xs={12}>
          <EmptyPageState
            IconComp={() => <PartyPopperIcon />}
            title="No activity plans found."
            removeButton
          />
        </Grid>
      </Box>
    )
  }

  return (
    <Box className={classes.page}>
      <LessonPlanDetailView planHit={planHit} activityHits={activityHits} />
    </Box>
  )
}

export default SinglePlansPage
